/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Change_AnytimeInputs */



/**
* | output |
* | --- |
* | "You can change your plan at any time." |
*
* @param {Plan_Gate_Change_AnytimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_change_anytime = /** @type {((inputs?: Plan_Gate_Change_AnytimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Change_AnytimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du kannst deinen Plan jederzeit ändern.")
	return /** @type {LocalizedString} */ ("You can change your plan at any time.")
});